module.exports = __webpack_public_path__ + "static/media/eduYellow.39d8c8b9.svg";